import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetRevenueComparisonAPI } from "api/revenueComparisonApi";
import { get } from "lodash";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  comparisonData: {},
  loading: false,
};

export const getRevenueComparison = createAsyncThunk(
  "revenueComparison/getRevenueComparison",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GetRevenueComparisonAPI(data);
      return response.data;
    } catch (err) {
      console.log("error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const revenueComparisonSlice = createSlice({
  name: "revenueComparison",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getRevenueComparison.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRevenueComparison.fulfilled, (state, { payload }) => {
        state.comparisonData = get(payload, "data", {});
        state.loading = false;
      })
      .addCase(getRevenueComparison.rejected, (state) => {
        state.loading = false;
      }),
});

export default revenueComparisonSlice.reducer;
